<template>
  <div>
    <hero-bar>
      Job Sheets
    </hero-bar>
    <section class='section is-main-section'>
      <card-component title='' icon='ballot'>
<b-field grouped group-multiline>
            <div class='control'>
                <b-switch v-model='showDetailIcon'>Show detail icon</b-switch>
            </div>
        </b-field>

        <b-table
            :data='dataC'
            ref='table'
            paginated
            per-page='5'
            :opened-detailed='defaultOpenedDetails'
            detailed
            detail-key='id'
            @details-open='(row) => $buefy.toast.open(`Expanded ${row.user.first_name}`)'
            :show-detail-icon='showDetailIcon'
            aria-next-label='Next page'
            aria-previous-label='Previous page'
            aria-page-label='Page'
            aria-current-label='Current page'>

            <b-table-column field='id' label='ID' width='40' numeric v-slot='props'>
                {{ props.row.id }}
            </b-table-column>

            <b-table-column field='user.first_name' label='First Name' sortable v-slot='props'>
                <template v-if='showDetailIcon'>
                    {{ props.row.user.first_name }}
                </template>
                <template v-else>
                    <a @click='toggle(props.row)'>
                        {{ props.row.user.first_name }}
                    </a>
                </template>
            </b-table-column>

            <b-table-column field='user.last_name' label='Last Name' sortable v-slot='props'>
                {{ props.row.user.last_name }}
            </b-table-column>

            <b-table-column field='date' label='Date' sortable centered v-slot='props'>
                <span class='tag is-success'>
                    {{ new Date(props.row.date).toLocaleDateString() }}
                </span>
            </b-table-column>

            <b-table-column label='Gender' v-slot='props'>
                <span>
                    {{ props.row.gender }}
                </span>
            </b-table-column>

            <template slot='detail' slot-scope='props'>
                <article class='media'>
                    <figure class='media-left'>
                        <p class='image is-64x64'>
                            <img src='/static/img/placeholder-128x128.png'>
                        </p>
                    </figure>
                    <div class='media-content'>
                        <div class='content'>
                            <p>
                                <strong>{{ props.row.user.first_name }} {{ props.row.user.last_name }}</strong>
                                <small>@{{ props.row.user.first_name }}</small>
                                <small>31m</small>
                                <br>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Proin ornare magna eros, eu pellentesque tortor vestibulum ut.
                                Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.
                            </p>
                        </div>
                    </div>
                </article>
            </template>
        </b-table>
      </card-component>
    </section>
</div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import axios from 'axios'

import HeroBar from '@/components/HeroBar'
export default {
  name: 'Forms',
  components: { HeroBar, CardComponent },
  data () {
    return {
      jobs: [],
      props: null,
      isLoading: false,
      isHidden: false,
      isImageModalActive: false,
      form: {
        name: null,
        email: null,
        phone: null,
        status: 'Booked',
        subject: null,
        notes: null,
        radio: null,
        requestedPickup: new Date()
      },
      statuses: [
        'Pending',
        'Booked',
        'Delivered',
        'Complete'
      ],
      status: [
        { id: 1, name: 'Pending' },
        { id: 2, name: 'Booked' },
        { id: 3, name: 'In Transit' },
        { id: 4, name: 'Delivered' },
        { id: 5, name: 'Complete' }
      ],
      columns: [
        { field: 'date', label: 'Scheduled', width: '100' },
        { field: 'status', label: 'Status', width: '40' },
        { field: 'driver', label: 'Driver', width: '60' },
        { field: 'truck', label: 'Truck', width: '60' },
        { field: 'origin', label: 'Origin', width: '120' },
        { field: 'dest', label: 'Dest', width: '120' },
        { field: 'qty', label: 'Qty', width: '40' },
        { field: 'price', label: 'Price', width: '40' },
        { field: 'id', label: '', visible: false }],
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      dataC: [{ id: 1, user: { first_name: 'Jesse', last_name: 'Simmons' }, date: '2016/10/15 13:43:27', gender: 'Male' },
        { id: 2, user: { first_name: 'John', last_name: 'Jacobs' }, date: '2016/12/15 06:00:53', gender: 'Male' },
        { id: 3, user: { first_name: 'Tina', last_name: 'Gilbert' }, date: '2016/04/26 06:26:28', gender: 'Female' }
      ]
    }
  },
  computed: {
  },
  methods: {
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    },
    submit () {

    },
    async getJobs () {
      try {
        alert(this.address[0].address)
        const { data } = await axios.get(this.$store.state.apiUrl + 'transport?mode=app&row_type=transport_booking&orderby=day', {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        var i = 0
        for (i = 0; i < data.length; i++) {
          var statusName = ''
          statusName = this.status.find(x => x.id === data[i].status).name
          this.jobs.push({
            date: data[i].scheduledDate, driver: data[i].driverName, truck: data[i].truckName, origin: data[i].pickupAddress.addressName, dest: data[i].destinationAddress.addressName, qty: data[i].qty, price: data[i].priceCharged, status: statusName, id: data[i].bookingId
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    onChange (status) {
      this.isHidden = true
    },
    selectJob (record) {
      alert(record.id)
    },
    async getAddresses () {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'lookup/address', {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        this.addresses = data
      } catch (error) {
        console.log(error)
      }
    }
  },
  beforeMount () {
    this.getAddresses()
    this.getJobs()
  }
}
</script>
